import React from "react";
import emojiToolkit from "emoji-toolkit";

const emojiImgStyle =
  "display:inline-block;vertical-align:middle;width:20px;height:auto";

const escapeHtml = (text) =>
  String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

/** Pares válidos *negrito* / ~riscado~; * órfão e "* CPF" ficam literais. */
const applyWhatsAppMarkers = (text) => {
  // [^*] inclui \n — necessário p/ *Plataforma* no início de linha
  let result = text.replace(
    /(^|[^*])\*([^*\n]+?)\*(?!\*)/g,
    (match, prefix, content) => {
      if (/^\s|\s$/.test(content)) return match;
      return `${prefix}<strong>${content}</strong>`;
    }
  );

  result = result.replace(
    /(^|[^~])~([^~\n]+?)~(?!~)/g,
    (match, prefix, content) => {
      if (/^\s|\s$/.test(content)) return match;
      return `${prefix}<del>${content}</del>`;
    }
  );

  return result;
};

const linkify = (text) =>
  text.replace(
    /(^|[^/\w">])((?:https?:\/\/[^\s<>"']+)|(?:www\.[^\s<>"']+)|(?:wa\.me\/[^\s<>"']+))/gi,
    (full, prefix, url) => {
      let display = url;
      let trailing = "";
      const punct = url.match(/^(.*?)([.,;:!?]+)$/);
      if (punct) {
        display = punct[1];
        trailing = punct[2];
      }
      if (!display) return full;

      let href = display;
      if (/^(www\.|wa\.me\/)/i.test(display)) {
        href = `https://${display}`;
      }
      return `${prefix}<a href="${href}" target="_blank" rel="noopener noreferrer">${display}</a>${trailing}`;
    }
  );

const styleEmojiImgs = (html) =>
  html.replace(/<img\b(?![^>]*\bstyle=)[^>]*>/gi, (img) =>
    img.replace(/<img\b/i, `<img style="${emojiImgStyle}"`)
  );

/** Converte texto WhatsApp → HTML seguro (sem markdown-to-jsx). */
const toMessageHtml = (text) => {
  // 1) escape impede XSS; 2) marcadores/links viram tags nossas; 3) emoji → img (look antigo)
  let html = escapeHtml(text);
  html = applyWhatsAppMarkers(html);
  html = linkify(html);
  html = html.replace(/\n/g, "<br />");
  html = emojiToolkit.toImage(html);
  html = styleEmojiImgs(html);
  return html;
};

const MarkdownWrapper = ({ children }) => {
  const html = React.useMemo(() => {
    if (children == null || children === false || children === "") return null;
    if (typeof children !== "string") return null;
    return toMessageHtml(children);
  }, [children]);

  if (!html) return null;

  return <span dangerouslySetInnerHTML={{ __html: html }} />;
};

export default MarkdownWrapper;
